import { object, string } from "yup";

export default () => {
  return {
    localRecInfo: object()
      .nullable()
      .shape({
        local_rec_emails: string(),
      }),
  };
};
